import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { Form, Field } from '@smartplatform/ui';
import { Editor } from '../../components';
import Members from './Members';
import store from '../../store';
import './style.scss';

@observer
export default class Edit extends React.Component {
	
	@observable record = null;
	@observable error = null;
	@observable deputiesCount = 0;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Committee.findById(this.id, {
					include: [
						{
							relation: 'deputies',
							scope: {
								fields: { id: true, lastName: true, firstName: true, middleName: true, photo: true, },
							}
						}
					]
				});
				this.deputiesCount = this.record.deputies().length;
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.Committee();
		}
	};

	onDeputiesChange = (value) => this.deputiesCount = value;
	
	onSave = record => {
		if (this.id) {
			this.props.history.push(`/admin/committees`);
		}
		else {
			this.id = record.id;
			this.props.history.push(`/admin/committees/${record.id}`);
		}
	};

	onDelete = () => this.props.history.push(`/admin/committees`);
	
	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		return <>
			<Form record={this.record} stay={true} onSave={this.onSave} onDelete={this.onDelete} noDelete={!!this.deputiesCount} rootPath="/admin">
				<Field property="name" label="Наименование" />
				<Field property="about" label="Описание"><Editor /></Field>
				{this.record.id && <Members onDeputiesChange={this.onDeputiesChange} committee={this.record} />}
				<Field property="deactivated" label="В архиве" />
			</Form>
		</>;
	}
	
}
